import React from 'react';
import { Form, FormProps, FormRenderProps } from 'react-final-form';
import { Box } from '@mui/material';

import { Button, Typography, SelectAutocomplete } from '@occc-app/design-system';
import { Published_Status_Type } from '@occc/graphql';

import { CampaignComponentsFilterFormValues } from './types';

export type CampaignComponentsFilterFormProps = {
  onSubmit: FormProps<CampaignComponentsFilterFormValues>['onSubmit'];
  onReset: () => void;
  initialValues: Partial<CampaignComponentsFilterFormValues>;
};

const publishedStatusOptions = [
  { label: 'Published', value: Published_Status_Type.Published },
  { label: 'Unpublished', value: Published_Status_Type.Unpublished },
  { label: 'Expired', value: Published_Status_Type.Expired },
  { label: 'Archived', value: Published_Status_Type.Archived },
];

export const CampaignComponentsFilterForm = ({
  onSubmit,
  onReset,
  initialValues,
}: CampaignComponentsFilterFormProps) => {
  const renderForm: FormRenderProps<CampaignComponentsFilterFormValues>['render'] =
    React.useCallback(
      ({ handleSubmit, form }: FormRenderProps<CampaignComponentsFilterFormValues>) => {
        const reset = () => {
          form.reset();
          onReset();
        };

        return (
          <form onSubmit={handleSubmit}>
            <Box px={4} pt={4}>
              <Box mb={2}>
                <Typography paragraph>Publication Status</Typography>
                <SelectAutocomplete<keyof CampaignComponentsFilterFormValues>
                  name='publishedStatus'
                  label='Published Status'
                  placeholder='Select published status'
                  options={publishedStatusOptions}
                />
              </Box>
            </Box>
            <Box display='flex' justifyContent='flex-end' px={3} py={2}>
              <Button size='small' color='error' onClick={reset}>
                reset
              </Button>
              <Button type='submit' size='small' color='primary'>
                apply
              </Button>
            </Box>
          </form>
        );
      },
      [onReset],
    );
  return (
    <Form<CampaignComponentsFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
    />
  );
};
